import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export function getRtkErrorMessage(
  error: FetchBaseQueryError | SerializedError
): string {
  if ("status" in error) {
    return `${error.data}`;
  } else {
    return `(${error.code}) ${error.message}`;
  }
}
